import { fetch } from "../../index";
import { allKeyValues } from "../../queries/keyValues.js";

import { GRAPHQL_URL } from "../../constants";

export async function fetchAllKeyValues(blob) {
    return await fetch(GRAPHQL_URL, {
        query: allKeyValues(blob),
    });
}
